
<div
  v-if="isSpinnerVisible"
  id="spinner"
  class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
>
  <b-spinner :label="$t('chargement')"></b-spinner>
</div>
<div v-else :id="content.idHTML" :class="jel_getClassObject(content)">
  <div class="column">
    <div class="texte-noir">{{ content.libPrenom }}</div>
    <p class="texte" v-html="contentPrenom"></p>
    <div class="texte-noir">{{ content.libNom }}</div>
    <p class="texte" v-html="contentNom"></p>
    <div class="texte-noir">{{ content.libDateDeNaissance }}</div>
    <p class="texte" v-html="contentDateDeNaissance"></p>
    <div class="texte-noir">{{ content.libAdresse }}</div>
    <p class="texte" v-html="contentAdresse"></p>
  </div>
</div>
